import { inject, Injectable } from '@angular/core';

import type { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { HttpApiService } from '@core/http-legacy';

import type { ReferralsPortalProgram, ReferralsPortalProgramPayload } from '../types';

@Injectable({ providedIn: 'root' })
export class ProgramHttpService {
  private readonly httpApi = inject(HttpApiService);

  public loadProgram(): Observable<ReferralsPortalProgram> {
    return this.httpApi.get('/program').pipe(map(res => res.program));
  }

  public updateProgram(payload: ReferralsPortalProgramPayload): Observable<ReferralsPortalProgram> {
    return this.httpApi.patch('/program', null, { program: payload }).pipe(map(res => res.program));
  }
}
